import styled from 'styled-components';

export const AnalysisContainerStyled = styled.div`
  .loading_layout {
    height: calc(100vh - 486px);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .section_introduce_layout {
    margin-bottom: 22px;
  }
`;
